import { TIMESTAMP_PAYROLL_ALL } from '../../actions/types';

const initialState = { rows: [], isLoading: false, isCompleted: true };

export default function TimestampPayrollReducer(state = initialState, action) {
  switch (action.type) {
    case TIMESTAMP_PAYROLL_ALL:
      return { ...action.payload, isLoading: false, isCompleted: true };
    default:
      return state;
  }
}
